import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AuthActions } from 'common/auth/actions';
import { AuthLocalStorageKeys } from 'common/auth/constants';
import { DeviceHandoffActions } from 'common/deviceHandoff/state/actions';
import { readPersistedDeviceHandoff, subscribeToCrossTab } from 'common/deviceHandoff/state/persistence';
import { isFlowOwnedByThisTab } from 'common/utils/browserTabFlowOwner';
import { DEFAULT_PATH } from 'module/auth/login/login.utils';

/**
 * Watches localstorage keys to sync states between browser tabs e.g. auth states
 */
export function useBrowserTabSync() {
    const dispatch = useDispatch();

    useEffect(() => {
        const authListener = (event: StorageEvent) => {
            if (event.key === 'activeUser') {
                if (!event.newValue) {
                    if (readPersistedDeviceHandoff().phase !== 'inactive') {
                        dispatch(AuthActions.logOutPreservingDeviceHandoffState());

                        return;
                    }
                    dispatch(AuthActions.logoutRequest());

                    return;
                }
                if (event.newValue !== event.oldValue) {
                    localStorage.removeItem(AuthLocalStorageKeys.activeStudySite);
                    window.location.pathname = DEFAULT_PATH;

                    return;
                }
            }
        };

        window.addEventListener('storage', authListener);
        const unsubscribeHandoff = subscribeToCrossTab((handoffState) => {
            // The tab that owns the handoff keeps its own state; another tab must not wipe it.
            if (handoffState.phase === 'inactive' && isFlowOwnedByThisTab('deviceHandoff')) {
                return;
            }

            dispatch(DeviceHandoffActions.overwriteFromOtherTab(handoffState));
        });

        return () => {
            window.removeEventListener('storage', authListener);
            unsubscribeHandoff();
        };
    }, [dispatch]);
}
